var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
import { map, groupBy, sortBy } from 'lodash';
import { breakpoints, theme } from '@shapeable/theme';
import { formatDateTimeString } from '../../utils/format-datetime-string';
import { HeaderDivider } from '../elements/header-divider';
import { SessionLayout } from './session-layout';
import { useLang } from '../../hooks/use-lang';
var cls = classNames('event-session-list');
export var SessionListDefaultProps = {
  groupByTimeOfDay: true
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme.UNIT(10))
});
var SessionStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-bottom: ", ";\n\n    ", "\n  "], ["\n    margin-bottom: ", ";\n\n    ", "\n  "])), theme.UNIT(2), function (_a) {
    var showGap = _a.showGap;
    return showGap && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      margin-top: ", ";\n    "], ["\n      margin-top: ", ";\n    "])), theme.UNIT(10));
  }),
  tablet: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme.UNIT(4))
});
var SessionGroupStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var TimeOfDayGroupStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var TimeOfDayStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var GroupHeaderStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    font-size: ", ";\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "], ["\n    font-size: ", ";\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "])), theme.FONT_SIZE(16), theme.UNIT(8), theme.UNIT(4))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  TimeOfDayGroup: styled.div.attrs(cls.attr('time-of-day-group'))(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), TimeOfDayGroupStyles),
  TimeOfDay: styled(HeaderDivider)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), TimeOfDayStyles),
  SessionGroup: styled.div.attrs(cls.attr('session-group'))(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), SessionGroupStyles),
  GroupHeader: styled(HeaderDivider)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), GroupHeaderStyles),
  Session: styled(SessionLayout)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), SessionStyles)
};
export var SessionList = function SessionList(props) {
  var className = props.className,
      _a = props.items,
      items = _a === void 0 ? [] : _a,
      groupByTimeOfDay = props.groupByTimeOfDay,
      groupHeaderComponent = props.groupHeaderComponent;
  var t = useLang();
  var sessionsByTimeOfDay = groupBy(items, function (session) {
    var hour = parseInt(formatDateTimeString(session.startDate, 'H'));

    if (hour < 13) {
      return 'Morning';
    }

    if (hour < 19) {
      return 'Afternoon';
    }

    return 'Evening';
  });
  var GroupHeader = groupHeaderComponent || My.GroupHeader;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, groupByTimeOfDay ? map(sessionsByTimeOfDay, function (sessions, timeOfDay) {
    var lastGroupName = '';
    return React.createElement(My.TimeOfDayGroup, {
      key: "" + timeOfDay
    }, React.createElement(My.TimeOfDay, null, t(timeOfDay)), map(sortBy(sessions, function (session) {
      return "" + session.startDate + session.name;
    }), function (session) {
      var groupName = session.group && session.group.name;
      var ret = React.createElement(My.SessionGroup, {
        key: timeOfDay + "-" + session.id
      }, groupName && groupName !== lastGroupName && React.createElement(GroupHeader, null, groupName), React.createElement(My.Session, {
        showGap: !groupName && !!lastGroupName,
        entity: session,
        key: session.id
      }));
      lastGroupName = groupName;
      return ret;
    }));
  }) : items.map(function (session) {
    return React.createElement(My.Session, {
      showGap: false,
      entity: session,
      key: session.id
    });
  }));
};
SessionList.defaultProps = SessionListDefaultProps;
SessionList.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;